import * as Services from "../../../Service/Service";
import * as Url from "../../../Service/Url";

export const GetGeogDetails = async () => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_GEO_DETAILS, token);
  return res;
};

export const AddGeog = async (payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.ADD_GEO, payload, token);
  return res;
};

export const DeleteGeog = async (geogId) => {
  const token = localStorage.getItem("token");
  const params = { geogId };
  let res = await Services.DELETE(Url.DELETE_GEO + geogId, params, token);
  return res;
};

export const UpdateGeog = async (geogId, payload) => {
  const token = localStorage.getItem("token");
  let res = await Services.POST(Url.UPDATE_GEO + geogId, payload, token);
  return res;
};

// export const CsvDetails = () => {
//   const token = localStorage.getItem("token");

//   return axios.post(`${config.API_URL}/api/ACGGeog/CsvDetails`, {
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//   });
// };

// export const ImportGEO = async (payload) => {
//   const token = localStorage.getItem("token");
//   let res = await Services.POST(Url.IMPORT_GEO, payload, token);
//   return res;
// };

export const ImportGEO = (payload) => {
  const token = localStorage.getItem("token");

  let res = Services.POSTFORMDATA(
    `/api/ACGGeog/ImportGEO`,
    payload,
    token
  );
  return res;
};

export const GetGeogDetails_Paging = async (
  pageNum,
  pageSize,
) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_GEO_DETAILS_PAGGING + `PageNumber=${pageNum + 1}&PageSize=${pageSize}`, token);
  return res;
};

export const GetGeogDetails_Paging_Search = async (
  pageNum,
  pageSize,
  Search
) => {
  const token = localStorage.getItem("token");
  let res = await Services.GET(Url.GET_GEO_DETAILS_PAGGING_SEARCH + `PageNumber=${pageNum + 1}&PageSize=${pageSize}&Search=${Search}`, token);
  return res;
};
